(function () {
  document.querySelectorAll('[data-enc-product]').forEach(function (root) {
    var money = function (cents) { cents = parseInt(cents, 10) || 0; return '$' + (cents / 100).toFixed(2); };
    var esc = function (s) { var d = document.createElement('div'); d.textContent = (s == null ? '' : s); return d.innerHTML; };
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';

    /* ---------- Quantity (drives the order summary) ---------- */
    var qtyInput = root.querySelector('.enc-qty-input');
    var qMinus = root.querySelector('[data-enc-qty-minus]');
    var qPlus = root.querySelector('[data-enc-qty-plus]');
    function getQty() { var v = parseInt(qtyInput && qtyInput.value, 10); return (isNaN(v) || v < 1) ? 1 : v; }
    function setQty(v) { if (qtyInput) qtyInput.value = Math.max(1, v); updateAll(); }
    if (qMinus) qMinus.addEventListener('click', function () { setQty(getQty() - 1); });
    if (qPlus) qPlus.addEventListener('click', function () { setQty(getQty() + 1); });
    if (qtyInput) {
      qtyInput.addEventListener('change', function () { qtyInput.value = getQty(); updateAll(); });
      qtyInput.addEventListener('input', updateAll);
    }

    /* ---------- Gallery: featured image + thumbnail strip ---------- */
    var featuredImg = root.querySelector('[data-enc-featured-img]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-enc-thumb]'));
    var strip = root.querySelector('.enc-thumbs');
    function setFeatured(thumb) {
      if (!thumb) return;
      var full = thumb.getAttribute('data-enc-full');
      var srcset = thumb.getAttribute('data-enc-srcset');
      var alt = thumb.getAttribute('data-enc-alt') || '';
      if (featuredImg && full) {
        featuredImg.setAttribute('src', full);
        if (srcset) { featuredImg.setAttribute('srcset', srcset); } else { featuredImg.removeAttribute('srcset'); }
        featuredImg.setAttribute('alt', alt);
      }
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
    }
    function scrollStripTo(thumb) {
      if (!strip || !thumb) return;
      var left = thumb.offsetLeft - (strip.clientWidth - thumb.clientWidth) / 2;
      strip.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { setFeatured(t); scrollStripTo(t); }); });

    /* ---------- Upgrade cards: two-step Add -> choose color -> Added ---------- */
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-enc-up-card]'));
    function cardState(c) { return c.getAttribute('data-state') || 'idle'; }
    function cardHasColors(c) { return c.getAttribute('data-has-colors') === 'true'; }
    /* Phase 9.26 / Stage 3b — what is the customer choosing on this card? Colour on a bowl,
       Length on a grouped downstem. The section stamps data-enc-choice-noun; everything else
       defaults to Color so every existing card keeps its exact wording. */
    function choiceNoun(c) { return c.getAttribute('data-enc-choice-noun') || 'Color'; }
    function cardUnavailable(c) { return c.getAttribute('data-unavailable') === 'true'; }
    function cardInCart(c) { return c.getAttribute('data-state') === 'in-cart'; }
    function cardChosenColor(c) {
      var r = c.querySelector('[data-enc-up-color]:checked');
      if (!r) return null;
      return { value: r.value, isNoPref: (r.getAttribute('data-val') || '') === '' };
    }
    function syncColorLabels(c) {
      c.querySelectorAll('.enc-swatch, .enc-np, .encpoc-len').forEach(function (l) {
        var i = l.querySelector('[data-enc-up-color]');
        l.classList.toggle('is-active', !!(i && i.checked));
      });
    }
    function setChosenLabel(c) {
      var el = c.querySelector('[data-enc-up-chosen]');
      if (!el) return;
      var cc = cardChosenColor(c);
      if (cardHasColors(c) && cc) { el.textContent = choiceNoun(c) + ': ' + cc.value; el.hidden = false; }
      else { el.textContent = ''; el.hidden = true; }
    }
    function setBtnText(c, txt) { var b = c.querySelector('[data-enc-up-add] .enc-up-toggle-txt'); if (b) b.textContent = txt; }
    /* ---------- Phase 9.16: in-cart row (green status + orange-outlined Remove) ----------
       The row is markup rendered by the section and toggled ONLY by the state functions below,
       so there is exactly one place that decides whether a card looks in-cart. */
    function setIncartRow(c, on) { var r = c.querySelector('[data-enc-up-incart]'); if (r) r.hidden = !on; }
    function cardNoun(c) { return c.getAttribute('data-enc-up-noun') || 'that item'; }
    function showCardError(c, msg) {
      var el = c.querySelector('[data-enc-up-chosen]');
      if (!el) { showMsg(msg, 'error'); return; }
      el.textContent = msg; el.classList.add('is-err'); el.hidden = false;
    }
    function clearCardError(c) { var el = c.querySelector('[data-enc-up-chosen]'); if (el) el.classList.remove('is-err'); }
    function setIdle(c) {
      c.setAttribute('data-state', 'idle');
      c.removeAttribute('data-enc-incart-color');   // drop any colour adopted from a cart line
      var chk = c.querySelector('[data-enc-up-check]'); if (chk) chk.checked = false;
      var colors = c.querySelector('[data-enc-up-colors]'); if (colors) colors.hidden = true;
      c.querySelectorAll('[data-enc-up-color]').forEach(function (r) { r.checked = false; });
      syncColorLabels(c);
      c.classList.remove('is-selected'); c.classList.remove('is-incart');
      var btn = c.querySelector('[data-enc-up-add]'); if (btn) btn.setAttribute('aria-pressed', 'false');
      setBtnText(c, 'Add to Setup');
      setIncartRow(c, false); clearCardError(c);
      setChosenLabel(c);
    }
    function setChoosing(c) {
      c.setAttribute('data-state', 'choosing');
      var colors = c.querySelector('[data-enc-up-colors]'); if (colors) colors.hidden = false;
      var chk = c.querySelector('[data-enc-up-check]'); if (chk) chk.checked = false;
      c.classList.remove('is-selected');
      setIncartRow(c, false); clearCardError(c);
      setBtnText(c, 'Choose ' + choiceNoun(c).toLowerCase());
    }
    function setAdded(c) {
      c.setAttribute('data-state', 'added');
      var chk = c.querySelector('[data-enc-up-check]'); if (chk) chk.checked = true;
      c.classList.add('is-selected'); c.classList.remove('is-incart');
      var btn = c.querySelector('[data-enc-up-add]'); if (btn) btn.setAttribute('aria-pressed', 'true');
      setBtnText(c, '\u2713 Added to Setup');
      setIncartRow(c, false); clearCardError(c);
      setChosenLabel(c);
    }
    // in-cart = this accessory is ALREADY in the Shopify cart. Read-only in the builder:
    // never returned by selectedCards(), never submitted by buildItems(); clicking routes to /cart.
    function setInCart(c, line) {
      c.setAttribute('data-state', 'in-cart');
      var colors = c.querySelector('[data-enc-up-colors]'); if (colors) colors.hidden = true;
      var chk = c.querySelector('[data-enc-up-check]'); if (chk) chk.checked = false;
      c.classList.add('is-incart'); c.classList.remove('is-selected');
      var btn = c.querySelector('[data-enc-up-add]'); if (btn) btn.setAttribute('aria-pressed', 'true');
      setBtnText(c, 'In cart');
      setIncartRow(c, true);
      var el = c.querySelector('[data-enc-up-chosen]');
      if (el) {
        var parts = [];
        if (line.props['Color']) parts.push('Color: ' + line.props['Color']);
        else if (c.getAttribute('data-enc-incart-color')) parts.push('Color: ' + c.getAttribute('data-enc-incart-color'));
        if (line.props['Joint Size']) parts.push(line.props['Joint Size']);
        if (line.props['Size']) parts.push('Size: ' + line.props['Size']);
        if (line.quantity > 1) parts.push('Qty ' + line.quantity);
        // The green ✓ In cart status and the Remove button now live in the in-cart row, so this
        // line carries only the line's own details. 'manage in cart' is gone: removal is here.
        el.classList.remove('is-err');
        el.textContent = parts.join(' · ');
        el.hidden = !parts.length;
      }
    }
    cards.forEach(function (c) {
      if (cardUnavailable(c)) return;
      var btn = c.querySelector('[data-enc-up-add]');
      if (btn) btn.addEventListener('click', function () {
        if (cardInCart(c)) { window.location = cartUrl; return; }   // read-only: manage in cart
        var st = cardState(c);
        if (st === 'added') { setIdle(c); updateAll(); return; }
        if (cardHasColors(c)) {
          if (st === 'choosing') { setIdle(c); }   // cancel
          else { setChoosing(c); }
        } else {
          setAdded(c); updateAll();               // no colors -> select immediately
        }
      });
      c.querySelectorAll('[data-enc-up-color]').forEach(function (r) {
        // radio sits above the swatch (z-index) so pointer lands on it
        r.addEventListener('change', function () {
          if (cardInCart(c)) return;
          // Variant mode: the swatch IS the variant. Point the card at the exact referenced variant
          // before staging, so buildItems() submits that id and never a colour-as-property.
          var rv = r.getAttribute('data-enc-variant-id');
          if (rv) c.setAttribute('data-variant-id', rv);
          /* Phase 9.26 / Stage 3b — variant mode may span variants at different prices. Adopt the
             chosen variant's price so upgradesTotalCents(), the setup subtotal and the CTA total
             all follow the selection instead of the card's seed price. Absent attribute = no
             change, so colour swatches that carry no price behave exactly as before. */
          var rp = r.getAttribute('data-enc-variant-price');
          if (rp !== null && rp !== '') c.setAttribute('data-price', rp);
          syncColorLabels(c); setAdded(c); updateAll();
        });
      });
      // Mobile-only compact controls (hidden on desktop). Reuse the SAME state functions — no separate logic.
      var chBtn = c.querySelector('[data-enc-up-change]');
      if (chBtn) chBtn.addEventListener('click', function () {
        if (cardInCart(c)) { window.location = cartUrl; return; }
        setChoosing(c); updateAll();
        var col = c.querySelector('[data-enc-up-colors]'); if (col && col.scrollIntoView) col.scrollIntoView({ block: 'nearest' });
      });
      var rmBtn = c.querySelector('[data-enc-up-remove]');
      if (rmBtn) rmBtn.addEventListener('click', function () { if (cardInCart(c)) { window.location = cartUrl; return; } setIdle(c); updateAll(); });
      // Phase 9.16: remove THIS accessory's cart line. preventDefault + stopPropagation because
      // the button sits inside form.enc-form and must never submit the main product form.
      var rmCart = c.querySelector('[data-enc-up-cartremove]');
      if (rmCart) rmCart.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); removeCartLine(c); });
    });
    function clearUpsellSelections() { cards.forEach(function (c) { if (!cardUnavailable(c) && !cardInCart(c)) setIdle(c); }); }
    function selectedCards() { return cards.filter(function (c) { return cardState(c) === 'added' && !cardUnavailable(c); }); }
    function upgradesTotalCents() { return selectedCards().reduce(function (s, c) { return s + (parseInt(c.getAttribute('data-price'), 10) || 0); }, 0); }

    /* ---------- Cart hydration (reflect the REAL cart; never re-submit an existing line) ----------
       /cart.js is the source of truth. Existing lines render under "Already in your cart" using
       Shopify's final_line_price (so the $38.21 member price stays authoritative). New selections
       render under "Adding now". Targeted Option B: only a member-login RETURN (one-time session
       flag) triggers a single idempotent cart re-evaluation; ordinary loads only READ the cart. */
    var pricingEl = root.querySelector('[data-enc-is-member]');
    var isMember = !!(pricingEl && pricingEl.getAttribute('data-enc-is-member') === 'true');
    var bongVariantId = (function () { var f = root.querySelector('form.enc-form [name="id"]') || root.querySelector('form [name="id"]'); return f ? String(f.value) : ''; })();
    var cartState = { loaded: false, lines: [], byVariant: {}, bongLine: null };
    var reevalFailed = false;
    var PENDING_KEY = 'enc_member_login_pending';
    function pendingGet() { try { return sessionStorage.getItem(PENDING_KEY) === '1'; } catch (e) { return false; } }
    function pendingSet() { try { sessionStorage.setItem(PENDING_KEY, '1'); } catch (e) {} }
    function pendingClear() { try { sessionStorage.removeItem(PENDING_KEY); } catch (e) {} }
    function publicProps(props) { var o = {}; if (props) Object.keys(props).forEach(function (k) { if (String(k).charAt(0) !== '_') o[k] = props[k]; }); return o; }
    function fetchCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); }); }
    // One idempotent recalculation: toggle a PRIVATE CART ATTRIBUTE only (never a line-item property,
    // never merchandise/quantity), then restore attributes. Preserves token/keys/variants/props.
    function forceReeval() {
      return fetchCart().then(function (cart) {
        // Baseline WITHOUT any stray re-eval marker, so a leftover can never be reintroduced.
        var srcAttrs = cart.attributes || {}; var orig = {};
        Object.keys(srcAttrs).forEach(function (k) { if (!/reeval/i.test(k)) orig[k] = srcAttrs[k]; });
        var bump = {}; Object.keys(orig).forEach(function (k) { bump[k] = orig[k]; }); bump._enc_reeval = '1';
        var H = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
        // Empty string DELETES a cart attribute. Clear our marker plus any legacy reeval key; keep others.
        function stripReeval(attrs) { var out = { _enc_reeval: '' }; Object.keys(attrs || {}).forEach(function (k) { if (/reeval/i.test(k)) out[k] = ''; }); return out; }
        return fetch('/cart/update.js', { method: 'POST', headers: H, credentials: 'same-origin', body: JSON.stringify({ attributes: bump }) })
          .then(function (r) { if (!r.ok) throw new Error('reeval'); return r.json(); })
          .then(function (afterBump) {
            return fetch('/cart/update.js', { method: 'POST', headers: H, credentials: 'same-origin', body: JSON.stringify({ attributes: stripReeval(afterBump.attributes) }) }).then(function (r) { return r.ok ? r.json() : afterBump; });
          })
          .then(function (afterStrip) {
            // Safety net: never leave a reeval marker behind, even if a prior POST was interrupted.
            var lingering = Object.keys((afterStrip && afterStrip.attributes) || {}).filter(function (k) { return /reeval/i.test(k); });
            if (!lingering.length) return afterStrip;
            var strip = {}; lingering.forEach(function (k) { strip[k] = ''; });
            return fetch('/cart/update.js', { method: 'POST', headers: H, credentials: 'same-origin', body: JSON.stringify({ attributes: strip }) }).catch(function () {});
          })
          .then(function () { return fetchCart(); });
      });
    }
    // Refresh the theme's cart sections in place after a re-evaluation, WITHOUT opening the drawer.
    // Mirrors CartDrawer.renderContents' innerHTML swap for cart-drawer / cart-icon-bubble /
    // cart-live-region-text, but deliberately omits the open() call (no auto open/close).
    function refreshCartSections() {
      var toRender = [
        { id: 'cart-drawer', selector: '#CartDrawer' },
        { id: 'cart-icon-bubble', selector: null },
        { id: 'cart-live-region-text', selector: null }
      ];
      var ids = toRender.map(function (s) { return s.id; }).join(',');
      return fetch('/?sections=' + encodeURIComponent(ids), { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          toRender.forEach(function (s) {
            var html = sections && sections[s.id]; if (html == null) return;
            var live = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
            if (!live) return;
            try {
              var sel = s.selector || '.shopify-section';
              var srcEl = new DOMParser().parseFromString(html, 'text/html').querySelector(sel);
              if (srcEl) live.innerHTML = srcEl.innerHTML;
            } catch (e) {}
          });
          var di = document.querySelector('cart-drawer .drawer__inner');
          if (di && di.classList.contains('is-empty')) di.classList.remove('is-empty');
        }).catch(function () {});
    }
    function ingestCart(cart) {
      cartState.loaded = true; cartState.lines = []; cartState.byVariant = {}; cartState.bongLine = null;
      (cart && cart.items || []).forEach(function (it) {
        var line = { variantId: String(it.variant_id), key: it.key, quantity: it.quantity, props: publicProps(it.properties), title: it.product_title || it.title, finalLine: it.final_line_price, finalPrice: it.final_price, origLine: it.original_line_price, discounted: (typeof it.original_line_price === 'number' && it.original_line_price > it.final_line_price) };
        cartState.lines.push(line);
        (cartState.byVariant[line.variantId] = cartState.byVariant[line.variantId] || []).push(line);
        if (line.variantId === bongVariantId) cartState.bongLine = line;
      });
    }
    function bongInCart() { return !!cartState.bongLine; }
    // The member discount is only "active" once the eligible bong line actually carries it in /cart.js.
    function memberDiscountConfirmed() {
      var b = cartState.bongLine;
      return !!(b && typeof b.origLine === 'number' && b.origLine > b.finalLine);
    }
    // Never assert "Encore Member pricing active" from the customer tag alone. Confirm the cart holds
    // the discount; otherwise state honestly that it confirms at checkout.
    function applyMemberConfirmation() {
      if (!isMember) return;
      var confirmed = memberDiscountConfirmed();
      var nodes = root.querySelectorAll('.enc-member-status, .enc-pm-status');
      Array.prototype.forEach.call(nodes, function (el) {
        var checkClass = el.classList.contains('enc-pm-status') ? 'enc-pm-check' : 'enc-member-check';
        el.innerHTML = confirmed
          ? '<span class="' + checkClass + '" aria-hidden="true">✓</span> Encore Member pricing active'
          : 'Member price will be confirmed at checkout';
      });
      // Member badge/pill goes green "✓ … ACTIVE" ONLY when the discount is genuinely confirmed in the
      // cart; otherwise it reverts to its original orange/neutral label (never green from the tag alone).
      var pills = root.querySelectorAll('.enc-member-pill, .enc-pm-badge');
      Array.prototype.forEach.call(pills, function (el) {
        if (!el.hasAttribute('data-enc-label-base')) el.setAttribute('data-enc-label-base', (el.textContent || '').trim());
        var base = el.getAttribute('data-enc-label-base') || 'Encore Member Price';
        if (confirmed) { el.classList.add('is-active'); el.textContent = '✓ ' + base + ' Active'; }
        else { el.classList.remove('is-active'); el.textContent = base; }
      });
    }
    // One-time, non-blocking success toast after a CONFIRMED member-login return. Accessible live region;
    // position:fixed (no layout shift); auto-dismisses (~4s); never touches or opens the cart drawer.
    var welcomeToastShown = false;
    function showWelcomeToast() {
      if (welcomeToastShown) return;                 // guard against double-show within one page life
      welcomeToastShown = true;
      var render = function () {
        var t = document.createElement('div');
        t.className = 'enc-toast';
        t.setAttribute('role', 'status');
        t.setAttribute('aria-live', 'polite');
        t.setAttribute('aria-atomic', 'true');
        t.innerHTML = '<span class="enc-toast-ic" aria-hidden="true">✓</span><span>Welcome back! Encore Member pricing is now active.</span>';
        document.body.appendChild(t);
        // Reveal on a short macrotask (not requestAnimationFrame, which is paused in inactive tabs).
        setTimeout(function () { t.classList.add('is-shown'); }, 30);
        setTimeout(function () {                        // ~4s on screen, then fade out and remove
          t.classList.remove('is-shown');
          setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 450);
        }, 4000);
      };
      // If the tab is hidden at return time (e.g. the login round-trip left it in the background),
      // defer until it's visible so the ~4s display isn't spent off-screen. Normal returns are visible.
      if (document.visibilityState === 'hidden') {
        var onVis = function () { if (document.visibilityState !== 'hidden') { document.removeEventListener('visibilitychange', onVis); render(); } };
        document.addEventListener('visibilitychange', onVis);
      } else {
        render();
      }
    }
    function cardFixedProps(c) {
      var p = {};
      if (c.getAttribute('data-requires-joint') === 'true' && c.getAttribute('data-joint-config')) p['Joint Size'] = c.getAttribute('data-joint-config');
      if (c.getAttribute('data-requires-size') === 'true' && c.getAttribute('data-size-config')) p['Size'] = c.getAttribute('data-size-config');
      return p;
    }
    // Match a card to a cart line by variant ID PLUS the card's applicable fixed properties
    // (Joint Size / Size). Color is customer-chosen, so the exact per-line values are shown from
    // /cart.js in the summary; the card badge only needs variant + fixed-prop identity.
    // Variant-mode cards encode the colour IN the variant id, so the card's server-rendered
    // default (the first referenced variant) will not match a cart line for any other colour and
    // the card would wrongly look stageable after a reload. Try every swatch's variant id; on a
    // hit, adopt that variant onto the card and restore its radio + swatch highlight so the badge
    // reflects what is actually in the cart. Property-mode and colourless cards never reach this
    // branch and are matched exactly as before.
    function cardMatchLineVariant(c) {
      var radios = c.querySelectorAll('[data-enc-up-color][data-enc-variant-id]');
      var fixed = cardFixedProps(c); var keys = Object.keys(fixed);
      for (var i = 0; i < radios.length; i++) {
        var rv = String(radios[i].getAttribute('data-enc-variant-id') || '');
        if (!rv) continue;
        var lines = cartState.byVariant[rv];
        if (!lines || !lines.length) continue;
        for (var j = 0; j < lines.length; j++) {
          var ln = lines[j], ok = true;
          for (var k = 0; k < keys.length; k++) { if (ln.props[keys[k]] !== fixed[keys[k]]) { ok = false; break; } }
          if (!ok) continue;
          c.setAttribute('data-variant-id', rv);          // adopt the variant that is really in the cart
          radios[i].checked = true;                       // programmatic: does NOT fire 'change'
          syncColorLabels(c);                             // restore the visual swatch highlight
          c.setAttribute('data-enc-incart-color', radios[i].value);
          return ln;
        }
      }
      return null;
    }
    function cardMatchLine(c) {
      if (c.getAttribute('data-color-mode') === 'variant') return cardMatchLineVariant(c);
      var vid = String(c.getAttribute('data-variant-id') || ''); if (!vid) return null;
      var lines = cartState.byVariant[vid]; if (!lines || !lines.length) return null;
      var fixed = cardFixedProps(c); var keys = Object.keys(fixed);
      for (var i = 0; i < lines.length; i++) {
        var ln = lines[i], ok = true;
        for (var k = 0; k < keys.length; k++) { if (ln.props[keys[k]] !== fixed[keys[k]]) { ok = false; break; } }
        if (ok) return ln;
      }
      return null;
    }
    function hydrateCards() {
      cards.forEach(function (c) {
        if (cardUnavailable(c)) return;
        var ln = cardMatchLine(c);
        if (ln) { setInCart(c, ln); }
        else if (cardInCart(c)) { setIdle(c); }   // no longer in cart -> back to idle
      });
    }
    function hydrateAll(cart) { ingestCart(cart); hydrateCards(); updateAll(); }

    /* ---------- External cart-sync: keep the PDP in step with drawer / cart-page mutations ----------
       The PDP publishes its own adds (source:'enc-product') but historically never LISTENED for cart
       changes made elsewhere (e.g. removing the bong from the cart drawer). That left cartState stale,
       so bongInCart() stayed true and the main CTA was stuck on "View cart" until a full reload.
       We now subscribe to the theme's cartUpdate event and re-read /cart.js on any external change. */
    var cartFetchSeq = 0;     // monotonic token; only the newest fetch is allowed to apply
    var cartSubBound = false; // idempotency guard: bind the subscriber at most once per PDP instance
    // Fetch /cart.js and apply hydrateAll ONLY if this remains the most recent request, so a slow
    // earlier response can never overwrite fresher state (last-initiated wins).
    function hydrateFresh() {
      var token = ++cartFetchSeq;
      return fetchCart().then(function (cart) {
        if (token !== cartFetchSeq) return;   // a newer fetch superseded this one -> drop stale result
        hydrateAll(cart);
      }).catch(function () {});
    }
    /* ---------- Phase 9.16: remove one accessory line, via Shopify's own cart path ----------
       POST /cart/change with the LINE KEY, which identifies variant + properties exactly, so a
       second line of the same variant with different properties is never touched. Then reuse the
       existing refreshCartSections() (drawer + bag bubble + live region, no auto-open) and
       hydrateFresh() (/cart.js -> cards, summary, totals, sticky, duplicate prevention). No
       second cart state is created and nothing is assumed about the outcome: the card only
       leaves in-cart because /cart.js stopped reporting the line. */
    var removing = [];
    function removeCartLine(c) {
      if (removing.indexOf(c) !== -1) return;                 // ignore repeat clicks in flight
      var ln = cardMatchLine(c);
      if (!ln || !ln.key) { hydrateFresh(); return; }          // nothing matched -> resync, claim nothing
      removing.push(c);
      var btn = c.querySelector('[data-enc-up-cartremove]');
      if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
      clearCardError(c);
      var changeUrl = (window.routes && window.routes.cart_change_url) || '/cart/change';
      fetch(changeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: ln.key, quantity: 0 })
      }).then(function (r) {
        return r.json().catch(function () { return null; }).then(function (body) { return { ok: r.ok, body: body }; });
      }).then(function (res) {
        if (!res.ok || !res.body || res.body.status) throw new Error('cart-change');
        try { if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'enc-product', cartData: res.body }); } catch (e) {}
        return refreshCartSections().then(function () { return hydrateFresh(); });
      }).catch(function () {
        // Re-read the cart FIRST so the card reflects reality, then report the failure on it.
        // If the line survived, hydrateCards() puts the card back to in-cart before this shows.
        return hydrateFresh().then(function () {
          showCardError(c, 'Could not remove that ' + cardNoun(c).toLowerCase() + ' — it is still in your cart. Please try again.');
        });
      }).then(function () {
        var i = removing.indexOf(c); if (i !== -1) removing.splice(i, 1);
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
      });
    }

    function bindExternalCartSync() {
      if (cartSubBound) return;               // never double-subscribe, even if initCart re-runs
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.cartUpdate) return;
      cartSubBound = true;
      try {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
          if (event && event.source === 'enc-product') return;  // ignore our own publishes -> no loop
          hydrateFresh();                     // drawer / cart page changed the cart -> re-sync the PDP
        });
      } catch (e) { cartSubBound = false; }
    }

    /* ---------- Count + preview subtotal + order summary ---------- */
    var upCountEl = root.querySelector('[data-enc-upsell-count]');
    var upSubtotalEl = root.querySelector('[data-enc-upsell-subtotal]');
    var upAmountEl = root.querySelector('[data-enc-upsell-amount]');
    function updateUpsell() {
      var sel = selectedCards();
      if (upCountEl) {
        upCountEl.textContent = sel.length + ' upgrade' + (sel.length === 1 ? '' : 's') + ' selected';
        upCountEl.classList.toggle('is-on', sel.length > 0);
      }
      if (upSubtotalEl) upSubtotalEl.hidden = sel.length === 0;
      if (upAmountEl) upAmountEl.textContent = money(upgradesTotalCents());
    }

    var summaryEl = root.querySelector('[data-enc-summary]');
    var basePrice = summaryEl ? (parseInt(summaryEl.getAttribute('data-base-price'), 10) || 0) : 0;
    var baseTitle = summaryEl ? (summaryEl.getAttribute('data-base-title') || '') : '';
    var atcPriceEl = root.querySelector('[data-enc-atc-price]');
    function bongColorValue() { var r = root.querySelector('[data-enc-color-input]:checked'); return r ? r.value : null; }
    function addingBongCents() { return bongInCart() ? 0 : basePrice * getQty(); }
    function addingUpgCents() { return upgradesTotalCents(); }
    function addingNowCents() { return addingBongCents() + addingUpgCents(); }
    function inCartCents() { return cartState.lines.reduce(function (s, l) { return s + (l.finalLine || 0); }, 0); }
    function sumRow(name, metaArr, priceStr, plus) {
      return '<div class="enc-sum-row' + (plus ? ' enc-sum-upg' : '') + '"><span class="enc-sum-l"><span class="enc-sum-name">' + esc(name) + '</span>'
        + (metaArr && metaArr.length ? '<span class="enc-sum-meta">' + metaArr.join(' &middot; ') + '</span>' : '')
        + '</span><span class="enc-sum-price">' + priceStr + '</span></div>';
    }
    function propMeta(props) {
      var parts = [];
      if (props['Color']) parts.push('Color: ' + esc(props['Color']));
      if (props['Joint Size']) parts.push(esc(props['Joint Size']));
      if (props['Size']) parts.push('Size: ' + esc(props['Size']));
      Object.keys(props).forEach(function (k) { if (['Color', 'Joint Size', 'Size'].indexOf(k) === -1) parts.push(esc(k) + ': ' + esc(props[k])); });
      return parts;
    }
    function updateSummary() {
      var qty = getQty();
      var addBong = !bongInCart();
      var addBongC = addingBongCents();
      var newCards = selectedCards();
      var addUpgC = addingUpgCents();
      var addingTotal = addBongC + addUpgC;
      var inCartTotal = cartState.loaded ? inCartCents() : 0;
      var grand = inCartTotal + addingTotal;

      if (atcPriceEl) atcPriceEl.textContent = (atcMode() === 'view') ? '' : ('· ' + money(addingTotal));
      if (!summaryEl) return;

      var html = '<div class="enc-sum-h">Order summary</div>';

      if (cartState.loaded && cartState.lines.length) {
        html += '<div class="enc-sum-sec"><div class="enc-sum-sec-h">Already in your cart</div>';
        cartState.lines.forEach(function (l) {
          var meta = propMeta(l.props); if (l.quantity > 1) meta.push('Qty ' + l.quantity);
          html += sumRow(l.title, meta, money(l.finalLine), false);
        });
        html += '<div class="enc-sum-row enc-sum-sub"><span>In-cart subtotal</span><span>' + money(inCartTotal) + '</span></div></div>';
      }

      var hasAdding = addBong || newCards.length;
      if (hasAdding) {
        html += '<div class="enc-sum-sec"><div class="enc-sum-sec-h">Adding now</div>';
        if (addBong) {
          var bc = bongColorValue();
          html += sumRow(baseTitle, ['Color: ' + (bc ? esc(bc) : 'not selected'), 'Qty ' + qty], money(addBongC), false);
        }
        newCards.forEach(function (c) {
          var name = c.getAttribute('data-title');
          var price = parseInt(c.getAttribute('data-price'), 10) || 0;
          var conn = c.querySelector('.enc-up-conn'); conn = conn ? conn.textContent.trim() : '';
          var meta = [];
          if (conn) meta.push(esc(conn));
          if (cardHasColors(c)) { var cc = cardChosenColor(c); if (cc) meta.push('Color: ' + esc(cc.value)); }
          if (c.getAttribute('data-requires-joint') === 'true' && c.getAttribute('data-joint-config')) meta.push(esc(c.getAttribute('data-joint-config')));
          if (c.getAttribute('data-requires-size') === 'true' && c.getAttribute('data-size-config')) meta.push('Size: ' + esc(c.getAttribute('data-size-config')));
          html += sumRow(name, meta, '+' + money(price), true);
        });
        html += '<div class="enc-sum-row enc-sum-sub"><span>Adding-now subtotal</span><span>' + money(addingTotal) + '</span></div></div>';
      }

      html += '<div class="enc-sum-row enc-sum-total"><span>Estimated total</span><span>' + money(grand) + '</span></div>';
      if (reevalFailed) html += '<div class="enc-sum-note">Member pricing will finalize at checkout.</div>';
      else if (cartState.loaded && !hasAdding) html += '<div class="enc-sum-note">Everything is already in your cart.</div>';
      summaryEl.innerHTML = html;
    }
    function updateAll() { updateUpsell(); refreshAtc(); updateSummary(); updateSticky(); applyMemberConfirmation(); }

    /* ---------- Upgrade Your Order: gated reveal + collapsible dropdown (CP4) ---------- */
    var upGate = root.querySelector('[data-enc-upsell-gate]');
    var upBody = root.querySelector('[data-enc-upsell-body]');
    var upToggle = root.querySelector('[data-enc-upsell-toggle]');
    var upHideTimer = null;
    function expandBody() {
      if (!upBody || !upToggle) return;
      upToggle.setAttribute('aria-expanded', 'true');
      upBody.classList.add('is-open');
      upBody.style.maxHeight = upBody.scrollHeight + 'px';
      var done = function (e) {
        if (e && e.propertyName && e.propertyName !== 'max-height') return;
        if (upBody.classList.contains('is-open')) upBody.style.maxHeight = 'none';
        upBody.removeEventListener('transitionend', done);
      };
      upBody.addEventListener('transitionend', done);
    }
    function collapseBody() {
      if (!upBody || !upToggle) return;
      if (upBody.style.maxHeight === 'none') { upBody.style.maxHeight = upBody.scrollHeight + 'px'; void upBody.offsetHeight; }
      upToggle.setAttribute('aria-expanded', 'false');
      upBody.classList.remove('is-open');
      requestAnimationFrame(function () { upBody.style.maxHeight = '0px'; });
    }
    if (upToggle) upToggle.addEventListener('click', function () {
      if (upToggle.getAttribute('aria-expanded') === 'true') collapseBody(); else expandBody();
    });
    function revealGate() {
      if (!upGate) return;
      if (upHideTimer) { clearTimeout(upHideTimer); upHideTimer = null; }
      if (upGate.hidden) { upGate.hidden = false; collapseBody(); requestAnimationFrame(function () { upGate.classList.add('is-revealed'); }); }
    }
    function hideGate() {
      if (!upGate) return;
      collapseBody();
      clearUpsellSelections();
      upGate.classList.remove('is-revealed');
      if (upHideTimer) clearTimeout(upHideTimer);
      upHideTimer = setTimeout(function () { upGate.hidden = true; upHideTimer = null; }, 300);
    }

    /* ---------- Bong color selector (line-item property) + gallery swap + gate (CP3/CP4) ---------- */
    var colorInputs = Array.prototype.slice.call(root.querySelectorAll('[data-enc-color-input]'));
    var nameEl = root.querySelector('[data-enc-colorname]');
    var labels = Array.prototype.slice.call(root.querySelectorAll('.enc-color .enc-swatch, .enc-color .enc-np'));
    var COLOR_DEFAULT = nameEl ? nameEl.textContent : '';
    function applyColor(colorVal) {
      var visible;
      if (!colorVal) { thumbs.forEach(function (t) { t.classList.remove('enc-hide'); }); visible = thumbs; }
      else {
        visible = [];
        thumbs.forEach(function (t) { var m = t.getAttribute('data-enc-color') === colorVal; t.classList.toggle('enc-hide', !m); if (m) visible.push(t); });
      }
      var first = visible[0] || thumbs[0];
      setFeatured(first); scrollStripTo(first);
    }
    function refreshColorUI(moveGallery) {
      var checked = root.querySelector('[data-enc-color-input]:checked');
      labels.forEach(function (lbl) { var inp = lbl.querySelector('[data-enc-color-input]'); lbl.classList.toggle('is-active', !!(inp && inp.checked)); });
      if (checked) {
        if (nameEl) nameEl.textContent = checked.hasAttribute('data-enc-np') ? 'No preference' : checked.value;
        if (moveGallery) applyColor(checked.getAttribute('data-enc-color-val') || '');
        revealGate();
      } else {
        if (nameEl) nameEl.textContent = COLOR_DEFAULT;
        thumbs.forEach(function (t) { t.classList.remove('enc-hide'); });
        hideGate();
      }
      updateAll();
    }
    if (colorInputs.length) {
      colorInputs.forEach(function (inp) {
        inp.addEventListener('pointerdown', function () { inp._encWas = inp.checked; });
        inp.addEventListener('click', function () { if (inp._encWas) { inp.checked = false; } inp._encWas = false; refreshColorUI(true); });
        inp.addEventListener('change', function () { refreshColorUI(true); });
      });
      refreshColorUI(false);
    }

    /* ---------- Multi-item Add to Cart (CP5): one atomic /cart/add request ---------- */
    var form = root.querySelector('form.enc-form') || root.querySelector('form');
    var atc = root.querySelector('.enc-atc');
    var msgEl = root.querySelector('[data-enc-atc-msg]');
    var submitting = false;
    var atcTxtEl = atc ? atc.querySelector('.enc-atc-txt') : null;
    var atcOrigLabel = atcTxtEl ? atcTxtEl.textContent : 'Add to Cart';
    var stickyAtcEl = root.querySelector('[data-enc-sticky-atc]');
    var stickyTxtEl = stickyAtcEl ? stickyAtcEl.querySelector('.enc-sticky-atc-txt') : null;
    var stickyOrigLabel = stickyTxtEl ? stickyTxtEl.textContent : 'Add to Cart';
    function showMsg(text, kind) { if (!msgEl) return; msgEl.textContent = text || ''; msgEl.className = 'enc-atc-msg' + (kind ? ' is-' + kind : ''); msgEl.hidden = !text; }
    // 'view' = bong already in cart AND nothing new selected -> button becomes "View cart" (no add).
    // 'add'  = something to add (a new bong, and/or newly selected accessories).
    function atcMode() { return (bongInCart() && selectedCards().length === 0) ? 'view' : 'add'; }
    // CTA wording. The product noun is supplied by Liquid (from product.type) as a data attribute —
    // no product noun is ever hardcoded here. Any staged accessory switches to the setup wording.
    var ctaBase = root.getAttribute('data-enc-cta-base') || atcOrigLabel || 'Add to Cart';
    var ctaSetup = root.getAttribute('data-enc-cta-setup') || 'Add Complete Setup to Cart';
    function addLabel() { return selectedCards().length ? ctaSetup : ctaBase; }
    function refreshAtc() {
      if (submitting) return;
      var view = (atcMode() === 'view');
      if (atcTxtEl && atcOrigLabel !== 'Sold out') atcTxtEl.textContent = view ? 'View cart' : addLabel();
      if (stickyTxtEl && stickyOrigLabel !== 'Sold out') stickyTxtEl.textContent = view ? 'View cart' : addLabel();
    }
    function setLoading(on) {
      if (atc) {
        atc.disabled = on; atc.setAttribute('aria-disabled', on ? 'true' : 'false'); atc.classList.toggle('is-loading', on);
        var lbl = atc.querySelector('.enc-atc-txt');
        if (lbl) {
          if (on) { atc.setAttribute('data-enc-prev', lbl.textContent); lbl.textContent = 'Adding setup…'; }
          else { var p = atc.getAttribute('data-enc-prev'); if (p) lbl.textContent = p; }
        }
      }
      var sa = root.querySelector('[data-enc-sticky-atc]');
      if (sa) {
        sa.disabled = on; sa.classList.toggle('is-loading', on);
        var slbl = sa.querySelector('.enc-sticky-atc-txt');
        if (slbl) {
          if (on) { sa.setAttribute('data-enc-prev', slbl.textContent); slbl.textContent = 'Adding…'; }
          else { var sp = sa.getAttribute('data-enc-prev'); if (sp) slbl.textContent = sp; }
        }
      }
    }
    function buildItems() {
      var errors = [];
      var items = [];
      // Bong: include ONLY when it is not already in the cart (prevents a duplicate bong after login).
      if (!bongInCart()) {
        var idInput = form ? form.querySelector('[name="id"]') : null;
        var bongId = idInput ? idInput.value : '';
        if (!bongId) { errors.push('This product is unavailable to add right now.'); return { items: items, errors: errors }; }
        var bong = { id: bongId, quantity: getQty() };
        var bc = bongColorValue();
        if (bc) bong.properties = { 'Color': bc };  // specific or "No preference"; omitted if none chosen
        items.push(bong);
      }
      // Only NEWLY selected accessories ('added'); in-cart cards are never returned by selectedCards().
      selectedCards().forEach(function (c) {
        var vid = c.getAttribute('data-variant-id');
        var title = c.getAttribute('data-title') || 'accessory';
        if (!vid) { errors.push('Missing product for "' + title + '". Please re-select it.'); return; }
        if (cardUnavailable(c)) { errors.push('"' + title + '" is unavailable.'); return; }
        var props = {};
        if (cardHasColors(c)) {
          var cc = cardChosenColor(c);
          if (!cc) { errors.push('Choose a color for "' + title + '".'); return; }
          // Property mode carries the colour as a line-item property; variant mode already
          // encodes it in the variant id, so a Color property there would be redundant.
          if (c.getAttribute('data-color-mode') !== 'variant') props['Color'] = cc.value;
        }
        if (c.getAttribute('data-requires-joint') === 'true') {
          var jc = c.getAttribute('data-joint-config');
          if (!jc) { errors.push('The required joint configuration for "' + title + '" is missing. It was not added.'); return; }
          props['Joint Size'] = jc;
        }
        if (c.getAttribute('data-requires-size') === 'true') {
          var sz = c.getAttribute('data-size-config');
          if (!sz) { errors.push('The required size for "' + title + '" is missing. It was not added.'); return; }
          props['Size'] = sz;
        }
        var item = { id: vid, quantity: 1 };
        if (Object.keys(props).length) item.properties = props;
        items.push(item);
      });
      return { items: items, errors: errors };
    }
    if (form && atc) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (submitting) return;
        if (atcMode() === 'view') { window.location = cartUrl; return; }   // nothing new to add -> go to cart
        showMsg('', '');
        var built = buildItems();
        if (!built.items.length) { window.location = cartUrl; return; }
        if (built.errors.length) { showMsg(built.errors[0], 'error'); return; }
        submitting = true; setLoading(true);
        var cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        var sections = (cartEl && cartEl.getSectionsToRender) ? cartEl.getSectionsToRender().map(function (s) { return s.id; }) : [];
        var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
        if (cartEl && cartEl.setActiveElement) cartEl.setActiveElement(atc);
        fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: built.items, sections: sections.join(','), sections_url: window.location.pathname })
        }).then(function (r) { return r.json(); }).then(function (resp) {
          if (resp && resp.status) {  // e.g. 422 unprocessable — Shopify added nothing
            showMsg((resp.description || resp.message || 'Some items could not be added') + ' Your selections are saved.', 'error');
            // Nothing was added (the multi-item add is all-or-nothing), but a line may have been
            // rejected because it just went out of stock. Re-read /cart.js so the summary and the
            // in-cart badges reflect the TRUE cart rather than our optimistic view.
            hydrateFresh();
            return;
          }
          // The /cart/add succeeded — items are in the cart. Confirm success BEFORE touching the
          // cart-drawer render, so a UI hiccup (e.g. a response missing its `sections` payload,
          // which makes renderContents throw) can never be mis-reported as an add failure.
          // The atomic add logic itself is unchanged.
          showMsg('Added to cart.', 'success');
          try { if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'enc-product', cartData: resp }); } catch (e) {}
          if (cartEl && cartEl.renderContents) {
            if (resp.sections) {
              cartEl.classList.remove('is-empty');  // clear stale empty-state so Dawn shows the added lines (and open() traps focus on #CartDrawer, not the missing empty view)
              try { cartEl.renderContents(resp); } catch (e) {}
            }
          } else {
            window.location = cartUrl;
          }
          // Re-sync the PDP with the now-updated cart: just-added items move to "Already in your cart",
          // their cards become in-cart (read-only), and the bong-in-cart button rules re-apply.
          hydrateFresh();
        }).catch(function () {
          showMsg('Something went wrong adding to cart. Your selections are saved — please try again.', 'error');
          hydrateFresh();   // request outcome unknown -> re-read the cart, never guess
        }).finally(function () {
          submitting = false; setLoading(false); refreshAtc();
        });
      });
    }

    /* ---------- Sticky mobile Add to Cart (CP6): reuses the CP5 total + submit; no second cart path ---------- */
    var stickyBar = root.querySelector('[data-enc-sticky]');
    var stickyTotalEl = root.querySelector('[data-enc-sticky-total]');
    var stickyCountEl = root.querySelector('[data-enc-sticky-count]');
    function updateSticky() {
      if (!stickyTotalEl && !stickyCountEl) return;
      var view = (atcMode() === 'view');
      if (stickyTotalEl) stickyTotalEl.textContent = view ? money(inCartCents()) : money(addingNowCents());
      if (stickyCountEl) {
        var n = selectedCards().length;
        stickyCountEl.textContent = n ? ('+' + n + ' upgrade' + (n === 1 ? '' : 's')) : '';
        stickyCountEl.hidden = n === 0;
      }
    }
    if (stickyBar) {
      if (stickyBar.getAttribute('data-enc-available') === 'false') {
        stickyBar.hidden = true;                    // product unavailable: no sticky bar
      } else {
        document.body.classList.add('enc-has-sticky');
        // Avoid duplication: hide the sticky bar while the real Add to Cart button is on screen.
        if ('IntersectionObserver' in window && atc) {
          var sObs = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) { stickyBar.classList.toggle('is-hidden', e.isIntersecting); });
          }, { threshold: 0 });
          sObs.observe(atc);
        }
      }
    }

    /* ---------- Membership-login CTA: mark a one-time "return pending" flag (targeted Option B) ---------- */
    Array.prototype.slice.call(root.querySelectorAll('.enc-become, .enc-pm-join')).forEach(function (a) {
      a.addEventListener('click', function () { pendingSet(); });
    });

    /* ---------- Membership modal (legacy dev-preview hooks; inert once CTAs link to real login) ---------- */
    var overlay = root.querySelector('[data-enc-member-overlay]');
    var openBtns = Array.prototype.slice.call(root.querySelectorAll('[data-enc-open-member]'));
    var closeBtn = root.querySelector('[data-enc-member-close]');
    var unlockBtn = root.querySelector('[data-enc-unlock]');
    var lastFocus = null;
    function openModal() { if (!overlay) return; lastFocus = document.activeElement; overlay.hidden = false; var f = overlay.querySelector('input'); if (f) setTimeout(function () { f.focus(); }, 40); }
    function closeModal() { if (!overlay) return; overlay.hidden = true; if (lastFocus) lastFocus.focus(); }
    openBtns.forEach(function (b) { b.addEventListener('click', openModal); });
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (overlay) overlay.addEventListener('click', function (e) { if (e.target === overlay) closeModal(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && overlay && !overlay.hidden) closeModal(); });
    if (unlockBtn) unlockBtn.addEventListener('click', function () { root.setAttribute('data-enc-member-preview', 'on'); closeModal(); });

    /* ---------- initial paint + cart hydration ---------- */
    updateAll();
    (function initCart() {
      bindExternalCartSync();                 // subscribe to drawer / cart-page changes (idempotent)
      var pending = pendingGet();
      if (pending && isMember) {
        pendingClear();                       // consume the one-time flag immediately (no repeat on reload)
        var tok = ++cartFetchSeq;             // reserve a token; a newer external sync may supersede
        forceReeval().then(function (cart) {
          if (tok === cartFetchSeq) hydrateAll(cart);   // apply only if not already superseded
          refreshCartSections();
        }).catch(function () {
          // Re-evaluation failed: preserve the cart exactly, do NOT guess a discounted value.
          reevalFailed = true;
          hydrateFresh();
        }).then(function () {
          // After the re-eval settles (resolved OR caught), surface the one-time welcome toast ONLY when
          // a fresh /cart.js genuinely shows the eligible discount allocation on the bong line — never
          // from the login/tag alone. Tied to this one-time pending-login branch, so never on reloads.
          return fetchCart().then(function (fresh) {
            var b = fresh && fresh.items && fresh.items.filter(function (it) { return String(it.variant_id) === bongVariantId; })[0];
            if (b && typeof b.original_line_price === 'number' && b.original_line_price > b.final_line_price) showWelcomeToast();
          }).catch(function () {});
        });
      } else {
        pendingClear();                       // stale/irrelevant flag -> clear; ordinary load only READS
        hydrateFresh();                       // /cart.js failure -> keep default builder
      }
    })();
  });
})();
